import request from '@/utils/request'

//查询项目进度
export function projectStep(data) {
  return request({
    url: '/projectRecord/list',
    method: 'get',
    params: data
  })
}

//查询项目顾问
export function projectTime(data) {
  return request({
    url: '/projectTime/list',
    method: 'get',
    params: data
  })
}

//项目一览分页
export function projectRecordList(data) {
  return request({
    url: '/projectRecord/listPage',
    method: 'post',
    data
  })
}

//新增
export function addProjectRecord(data) {
  return request({
    url: '/projectRecord/save',
    method: 'post',
    data
  })
}

//编辑
export function updataProjectRecord(data) {
  return request({
    url: '/projectRecord/update',
    method: 'post',
    data
  })
}

//查询单个项目记录
export function oneProjectRecord(data) {
  return request({
    url: '/projectRecord/listById',
    method: 'get',
    params: data
  })
}

//删除
export function deleteProjectRecord(data) {
  return request({
    url: '/projectRecord/deleteById',
    method: 'get',
    params: data
  })
}
